import { render, staticRenderFns } from "./VInputFileDropzone.vue?vue&type=template&id=a05689f4&"
import script from "./VInputFileDropzone.vue?vue&type=script&lang=js&"
export * from "./VInputFileDropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports